import React from "react";
import { styled } from "@mui/material/styles";
import { 
  Menu, 
  MenuItem, 
  Avatar, 
  Box, 
  Typography, 
  Divider,
  Button
} from "@mui/material";
import LanguageIcon from '@mui/icons-material/Language';
import "../assets/img/icomoon/style.css";
import { closeSession } from "../lib/router";
import { useHistory } from "react-router-dom";
import { connect } from "../store";
import { useTranslation } from "react-i18next";
import { getUrl } from "../lib/utils";

// Styled Avatar component to match our custom styling
const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: "28px",
  height: "28px",
  marginRight: "25px",
  cursor: "pointer",
}));

const ProfileMenuItem = styled(MenuItem)({
  '&.MuiMenuItem-root': {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:focus': {
      backgroundColor: 'transparent',
    },
    '&.Mui-selected': {
      backgroundColor: 'transparent',
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'transparent',
    }
  }
});

const SimpleMenu = (props) => {
  const max_height = 100;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const history = useHistory();

  const { user } = props.store;
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const { t, i18n } = useTranslation("global");

  // Reusable navigation handler
  const handleNavigation = (callback) => {
    // First close the menu
    setAnchorEl(null);
    // Execute the callback after a small delay
    setTimeout(() => {
      callback();
    }, 50);
  };

  const getRolTranslate = (rol) => {
    return t(`roles.${rol}`);
  };

  return (
    <Box sx={{ display: "inline-flex", position: "relative" }}>
      <StyledAvatar
        src={user?.avatar ? getUrl(user.avatar) : undefined}
        alt={user?.name ? `${user.name} avatar` : "User avatar"}
        onClick={handleClick}
        aria-controls="simple-menu"
        aria-haspopup="true"
      />
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              maxHeight: max_height * 4.5,
              width: "387px",
              marginTop: "15px",
            },
          },
        }}
      >
        {/* User profile section */}
        <ProfileMenuItem 
          disableRipple
          sx={{ 
            display: 'block',
            textAlign: "center",
          }}
        >
          <Avatar
            src={user?.avatar ? getUrl(user.avatar) : undefined}
            alt={user?.name ? `${user.name} avatar` : "User avatar"}
            sx={{ width: 60, height: 60, mx: "auto", mb: 1 }}
          />
          <Typography variant="subtitle2">
            {user.name} {user.lastname}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {getRolTranslate(user.rol)}
          </Typography>
        </ProfileMenuItem>
        
        <Divider />

        {/* Account management option */}
        <MenuItem sx={{ justifyContent: "center" }}>
          <Button
            variant="outlined"
            size="small"
            onClick={() => handleNavigation(() => history.push('/UserProfile/'))}
            sx={{
              borderRadius: "30px",
              px: 1.5,
              py: 1,
              minWidth: 'auto',
              textTransform: "none",
            }}
          >
            {t("manage_account")}
          </Button>
        </MenuItem>
        
        <Divider />

        {/* Language option */}
        <MenuItem>
          <Box sx={{ 
            display: "flex", 
            width: "100%",
            justifyContent: "center",
            alignItems: "center", 
            gap: 2
          }}>
            <Box sx={{
              width: "35px",
              height: "35px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#EDEAFF",
              borderRadius: "100%",
              color: "#281B65",
              flexShrink: 0
            }}>
              <LanguageIcon fontSize="small" />
            </Box>
            
            <Typography>
              {t("language")}:
              <Typography
                component="span"
                sx={{
                  margin: "0 3px",
                  fontWeight: i18n.language === "es" ? 600 : 400,
                  cursor: "pointer",
                }}
                onClick={() => i18n.changeLanguage("es")}
              >
                ES
              </Typography>{" "}
              /{" "}
              <Typography
                component="span"
                sx={{
                  margin: "0 3px",
                  fontWeight: i18n.language === "en" ? 600 : 400,
                  cursor: "pointer",
                }}
                onClick={() => i18n.changeLanguage("en")}
              >
                EN
              </Typography>
            </Typography>
          </Box>
        </MenuItem>

        <Divider />

        {/* Sign off option */}
        <MenuItem 
          sx={{ 
            display: "flex", 
            justifyContent: "center"
          }}
        >
          <Button
            variant="outlined"
            size="small"
            sx={{
              borderRadius: "3px",
              px: 2,
              py: 1,
              minWidth: 'auto',
              textTransform: "none",
            }}
            onClick={() => handleNavigation(closeSession)}
          >
            {t("Sign_off")}
          </Button>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default connect(SimpleMenu);
